import axios from 'axios';

const sendOtp = (mobileNumber) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/user/send-otp`, { mobileNumber })
    .then(res => res)
    .catch(err => err);
};

export default sendOtp;
